import React from 'react';
import { ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';
import { Text, TextAs, TextSizes } from '@clockout-dev/design-elements';
import styles from './styles/kpi-delta.module.scss';

/**
 * Renders the numeric portion of a KPI delta row — an up/down arrow paired
 * with the percentage value, color-coded green for positive, red for
 * negative, and muted for the zero case. Callers should guard `null`
 * upstream; this component assumes a numeric `change`.
 */
function KpiDeltaPercent({ change }) {
    if (change > 0) {
        return (
            <>
                <ArrowUpOutlined className={`${styles.deltaIcon} ${styles.deltaUp}`} />
                <Text
                    as={TextAs.SPAN}
                    size={TextSizes.EXTRA_SMALL}
                    className={`${styles.deltaValue} ${styles.deltaUp}`}
                >
                    {change}%
                </Text>
            </>
        );
    }

    if (change < 0) {
        return (
            <>
                <ArrowDownOutlined className={`${styles.deltaIcon} ${styles.deltaDown}`} />
                <Text
                    as={TextAs.SPAN}
                    size={TextSizes.EXTRA_SMALL}
                    className={`${styles.deltaValue} ${styles.deltaDown}`}
                >
                    {Math.abs(change)}%
                </Text>
            </>
        );
    }

    return (
        <Text
            as={TextAs.SPAN}
            size={TextSizes.EXTRA_SMALL}
            className={`${styles.deltaValue} ${styles.deltaNeutral}`}
        >
            0%
        </Text>
    );
}

export default KpiDeltaPercent;
